module.exports = __webpack_public_path__ + "img/expovina_05(1).16a1f6f2.jpg";